// ======================================================================
// FILE:
// src/modules/service_crm/installed_products/components/InstalledProductsPagination.js
//
// MODULE: Service CRM
// FEATURE: Installed Products Pagination
// ======================================================================

import React from "react";

export default function InstalledProductsPagination({
  page = 1,
  pageSize = 10,
  total = 0,

  onPageChange,
  onPageSizeChange,
}) {

  // -------------------------------------------------------------------
  // CALCULATIONS
  // -------------------------------------------------------------------
  const totalPages =
    Math.ceil(total / pageSize);

  const startRecord =
    total === 0
      ? 0
      : ((page - 1) * pageSize) + 1;

  const endRecord =
    Math.min(
      page * pageSize,
      total
    );

  // -------------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------------
  return (

    <div
      style={{
        background: "#fff",

        borderRadius: 14,

        padding: 16,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",

        display: "flex",

        justifyContent:
          "space-between",

        alignItems: "center",

        flexWrap: "wrap",

        gap: 12,
      }}
    >

      {/* ========================================================= */}
      {/* RECORD INFO */}
      {/* ========================================================= */}

      <div
        style={{
          fontSize: 14,

          color: "#6c757d",
        }}
      >

        Showing
        {" "}
        <strong>
          {startRecord}
        </strong>

        {" "}to{" "}

        <strong>
          {endRecord}
        </strong>

        {" "}of{" "}

        <strong>
          {total}
        </strong>

        {" "}records

      </div>

      {/* ========================================================= */}
      {/* CONTROLS */}
      {/* ========================================================= */}

      <div
        style={{
          display: "flex",

          alignItems: "center",

          gap: 10,

          flexWrap: "wrap",
        }}
      >

        {/* PAGE SIZE */}
        <div
          style={{
            display: "flex",

            alignItems: "center",

            gap: 8,
          }}
        >

          <span
            style={{
              fontSize: 14,
            }}
          >
            Rows:
          </span>

          <select
            className="form-select form-select-sm"

            value={pageSize}

            style={{
              width: 90,
            }}

            onChange={(e) =>
              onPageSizeChange(
                Number(e.target.value)
              )
            }
          >

            <option value={10}>
              10
            </option>

            <option value={20}>
              20
            </option>

            <option value={50}>
              50
            </option>

            <option value={100}>
              100
            </option>

          </select>

        </div>

        {/* PAGE INFO */}
        <div
          style={{
            fontSize: 14,

            fontWeight: 600,

            minWidth: 90,

            textAlign: "center",
          }}
        >

          Page {page} / {totalPages || 1}

        </div>

        {/* PREVIOUS */}
        <button
          type="button"

          className="btn btn-sm btn-outline-secondary"

          disabled={page <= 1}

          onClick={() =>
            onPageChange(page - 1)
          }
        >
          Previous
        </button>

        {/* NEXT */}
        <button
          type="button"

          className="btn btn-sm btn-outline-primary"

          disabled={
            page >= totalPages
          }

          onClick={() =>
            onPageChange(page + 1)
          }
        >
          Next
        </button>

      </div>

    </div>
  );
}